import React, { useState } from "react";
import Sidebar from "../Components/SideBar";
import { useAuth } from "react-oidc-context";
import ProductionWindow from "../Components/Windows/productionWindow";


function wrapContent(auth, content) {
  switch (auth.activeNavigator) {
    case "signinSilent":
      return <div>Signing you in...</div>;
    case "signoutRedirect":
      return <div>Signing you out...</div>;
  }

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return <React.Fragment>{content()}</React.Fragment>;
  }
  auth.signinRedirect();
  //return <button onClick={() => void auth.signinRedirect()}>Log in</button>;
}

function content() {
  //const value = useContext(salesGovernanceContext); //to remove
  return (
    <React.Fragment>
      <div className="staticElement">
        <Sidebar />
      </div>
      <div className="productionWindow">
        
          <ProductionWindow />
      </div>
    </React.Fragment>
  );
}

function Production() {
  const auth = useAuth();

  return <div className="parentDiv">{wrapContent(auth, content)}</div>;
}

export default Production;
